import React from 'react'

const Upcoming = () => (
    <h1>Upcoming Features</h1>
)

export default Upcoming